import {useId, useState, type ReactNode} from 'react'
import {ChevronGlyph} from '@/components/ui/icons'
import {AREA_TACTIL} from '@/components/ui/info-tip'
import {cn} from '@/lib/utils'

export function TreeNode({
  label,
  meta,
  depth,
  children,
  defaultOpen = true,
  testId,
}: {
  label: ReactNode
  meta?: ReactNode
  depth: number
  children?: ReactNode
  defaultOpen?: boolean
  testId?: string
}) {
  const [open, setOpen] = useState(defaultOpen)
  // El botón solo tiene el chevrón: su nombre accesible lo presta el rótulo del nodo (U17).
  const labelId = useId()
  const hasChildren = children !== undefined && children !== null && children !== false
  return (
    <div
      style={{marginLeft: depth > 0 ? 16 : 0}}
      className={depth > 0 ? 'surface-divider border-l pl-3' : ''}
      data-testid={testId}>
      <div className="flex items-center gap-1.5 rounded-md px-1.5 py-1.5 transition-colors hover:bg-muted/55">
        {hasChildren ? (
          /* `AREA_TACTIL` da los 24×24 de WCAG 2.2 SC 2.5.8 sin ocupar layout. */
          <button
            type="button"
            aria-labelledby={labelId}
            aria-expanded={open}
            data-testid={testId ? `${testId}-toggle` : undefined}
            onClick={() => setOpen((o) => !o)}
            className={cn(
              'flex size-4 shrink-0 items-center justify-center text-muted-foreground hover:text-foreground',
              AREA_TACTIL
            )}>
            <ChevronGlyph size={12} className={open ? 'rotate-0' : '-rotate-90'} />
          </button>
        ) : (
          <span className="size-4 shrink-0" />
        )}
        <span id={labelId} className={cn('min-w-0 truncate text-sm text-foreground', depth === 0 && 'font-heading')}>
          {label}
        </span>
        {meta}
      </div>
      {hasChildren && open && <div>{children}</div>}
    </div>
  )
}
